module.exports = {
  "country": "DE",
  "artist": "Michael Schulte ",
  "song": "You let me walk alone",
  "year": "2018",
  "place": "4",
  "spotify": "07qlsG6DYRLBbovwca9Vbr"
};